<template>
  <a-card class="style1">
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminCreateMonthlyPage' })">Create Monthly Video</a-button>
    <a-table :loading="isLoading" :columns="columns" :data-source="pagesData" size="middle" bordered rowKey="id">
      <div slot="action" slot-scope="record" class="action">
        <a href="javascript:;" @click="onEdit(record.slug)">Edit</a>
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </div>
      <div slot="title" slot-scope="record">
        <a href="javascript:;" @click="onEdit(record.slug)">{{ record.title }}</a>
      </div>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>
  </a-card>
</template>
<script>
import { slugData } from '@/utils';
import AdminService from '@/services/AdminService';
import { includes } from 'lodash';
export default {
  data() {
    return {
      isLoading: true,
      pagesData: [],
      pagesList: [],
      columns: [
        {
          title: 'Title',
          key: 'title',
          scopedSlots: {
            customRender: 'title',
          },
        },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ].map(item => {
        if (item.key !== 'operation') {
          return {
            ...item,
            scopedSlots: {
              ...item.scopedSlots,
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
            },
            onFilter: (value, record) => record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value)),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          };
        }
        return item;
      }),
    };
  },
  watch: {
    pagesList: {
      async handler(val) {
        this.pagesData = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async doInitData() {
      this.pagesList = await AdminService.monthlyPages.getAll();
    },
    onEdit(pageSlug) {
      this.$router.push({ name: 'AdminMonthlyPageDetail', params: { pageSlug } });
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.monthlyPages.delete(record.id);
        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.name} was deleted successfully.`,
        });
        await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },

    handleReset(clearFilters) {
      clearFilters();
    },
  },
};
</script>
